import React from 'react';

const DeleteIcon = ({ color = '#46446F', size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 4.55556H2.77778M2.77778 4.55556H17M2.77778 4.55556V17.2222C2.77778 17.6937 2.96508 18.1459 3.29848 18.4793C3.63187 18.8127 4.08406 19 4.55556 19H13.4444C13.9159 19 14.3681 18.8127 14.7015 18.4793C15.0349 18.1459 15.2222 17.6937 15.2222 17.2222V4.55556M5.44444 4.55556V2.77778C5.44444 2.30628 5.63175 1.8541 5.96514 1.5207C6.29854 1.18731 6.75072 1 7.22222 1H10.7778C11.2493 1 11.7015 1.18731 12.0349 1.5207C12.3683 1.8541 12.5556 2.30628 12.5556 2.77778V4.55556" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default DeleteIcon;
